"use strict";
export function assertWebElement(element) {
  if (!(element instanceof HTMLDivElement)) {
    throw new Error("Element is not an HTMLDivElement");
  }
}
